import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-folder",
  "use": "icon-folder-usage",
  "viewBox": "0 0 24 24",
  "content": "<symbol viewBox=\"0 0 24 24\" fill=\"\" xmlns=\"http://www.w3.org/2000/svg\" id=\"icon-folder\">\n<path fill=\"\" d=\"M19 10H2L5 20H22L19 10Z\" clip-rule=\"evenodd\" fill-rule=\"evenodd\" undefined=\"1\" />\n<path fill=\"\" d=\"M22 20V4H16L14 6H4V10H19L22 20Z\" clip-rule=\"evenodd\" fill-rule=\"evenodd\" undefined=\"1\" />\n<path stroke-linejoin=\"round\" stroke-linecap=\"round\" stroke-miterlimit=\"10\" stroke-width=\"2\" stroke=\"#221b38\" d=\"M2 10H19L22 20\" />\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol